import {WidgetEventStruct} from '../../widget-event.struct';
import {DataManagementLogicalWidgetEnum, FirmwareWidgetEnum} from '../../../enums';
import {LogicalWidgetEventStruct} from '../logical';

export class DataManagementWidgetEventStruct extends LogicalWidgetEventStruct {
  public event_data_management_widget_type: DataManagementLogicalWidgetEnum;
} // end Package
